import {
	Loading,
	Table,
	type TableAction,
	type TableConfig,
} from 'src/components';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userTypes } from 'src/helpers/constants';
import _ from 'lodash';
import sectionActions from 'src/store/Sections/actions';

interface Props {
	courseId: number;
}

function Sections({ courseId }: Props) {
	const history = useHistory();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => state.auth.data);
	const { isLoading, sections } = useSelector(
		(state: RootState) => state.sections,
	);
	const updateOrder = (courseId: number, sections: any[]) =>
		dispatch(sectionActions.updateOrder(courseId, sections));

	const columns: TableConfig[] = [
		{
			key: 'name',
			label: 'Secciones',
			render: (value: any, row: any) => value,
		},
		{
			align: 'center',
			key: 'totalVideos',
			label: 'Vídeos',
			render: (value: any, row: any) => value,
		},
		{
			align: 'center',
			key: 'totalQuestions',
			label: 'Preguntas',
			render: (value: any, row: any) => value,
		},
		{
			align: 'center',
			key: 'questionsInExam',
			label: 'Preguntas examen',
			render: (value: any, row: any) => value,
		},
	];

	const actions: TableAction[] = [
		{
			label: 'Detalle',
			onClick: (row: any) => {
				history.push(`/app/courses/edit/${courseId}/section/${row.id}`);
			},
		},
	];

	return (
		<Loading isLoading={isLoading}>
			<Table
				actions={actions}
				columns={columns}
				data={_.sortBy(sections, 'sortOrder')}
				enableDrag={user.type === userTypes.ADMIN}
				handleDrag={(reorderedData: any[]) =>
					updateOrder(courseId, reorderedData)
				}
				hidePagination
			/>
		</Loading>
	);
}

export default Sections;
